"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Flex = require("../../../Layout/Flex");

var _Typography = require("../../Typography");

var _SidebarSubPanel = _interopRequireDefault(require("./SidebarSubPanel"));

var _VisuallyHidden = _interopRequireDefault(require("../../../VisuallyHidden"));

var _Constant = require("../../Constant");

function _templateObject4() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  ", " {\n    margin-left: 24px;\n  }\n\n  ", ":first-child {\n    margin-left: 0;\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  position: relative;\n  display: block;\n  width: 3.2rem;\n  height: 3.2rem;\n  outline: none;\n\n  &:before {\n    content: '';\n    background: url(", ") no-repeat center center;\n    background-size: 100% 100%;\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n  }\n\n  /* Focus styles on on keyboard focus */\n  &[data-focus-visible-added]:focus {\n    outline: 4px solid ", ";\n    outline-offset: 6px;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  padding-bottom: 1.6rem;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2.default)(["\n  padding: 2.4rem;\n  border-bottom: 1px solid ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var CommunityPanel = (0, _styledComponents.default)(_SidebarSubPanel.default)(_templateObject(), _Constant.Color.GREY_2);

var Div = _styledComponents.default.div(_templateObject2());

var SocialMediaLink = _styledComponents.default.a(_templateObject3(), function (_ref) {
  var image = _ref.image;
  return image;
}, _Constant.Color.FOCUS_B);

var SocialMediaContainer = (0, _styledComponents.default)(_Flex.FlexContainer)(_templateObject4(), _Flex.FlexItem, _Flex.FlexItem);
/**
 * Visually hidden link text is used to support assistive technology users.
 */

var MarketingCommunityItem = function MarketingCommunityItem(_ref2) {
  var socialMediaLinks = _ref2.socialMediaLinks,
      header = _ref2.header,
      description = _ref2.description,
      rest = (0, _objectWithoutProperties2.default)(_ref2, ["socialMediaLinks", "header", "description"]);
  return /*#__PURE__*/_react.default.createElement(CommunityPanel, rest, /*#__PURE__*/_react.default.createElement(Div, null, /*#__PURE__*/_react.default.createElement(_Typography.Typography.SidebarProductHeader, null, header), /*#__PURE__*/_react.default.createElement(_Typography.Typography.SidebarBody, null, description)), /*#__PURE__*/_react.default.createElement(SocialMediaContainer, null, socialMediaLinks.map(function (socialMediaLink) {
    return /*#__PURE__*/_react.default.createElement(_Flex.FlexItem, {
      key: socialMediaLink.url,
      "data-testid": "social"
    }, /*#__PURE__*/_react.default.createElement(SocialMediaLink, {
      image: socialMediaLink.icon,
      href: socialMediaLink.url,
      target: "_blank"
    }, /*#__PURE__*/_react.default.createElement(_VisuallyHidden.default, null, socialMediaLink.linkText, ". Opens in a new tab. ")));
  })));
};

MarketingCommunityItem.propTypes = {
  /** panel header */
  header: _propTypes.default.string.isRequired,

  /** panel description */
  description: _propTypes.default.string.isRequired,

  /** social media data objects */
  socialMediaLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    url: _propTypes.default.string,
    icon: _propTypes.default.node,
    linkText: _propTypes.default.string
  }))
};
MarketingCommunityItem.defaultProps = {
  socialMediaLinks: []
};
var _default = MarketingCommunityItem;
exports.default = _default;